import {
  Action,
  ActionType,
  IUpdateTemperatureResponse,
} from "models/setting/updateTemperature";
import createReducer from "../../createReducer";

export interface UpdateTemperatureSettingReducerType {
  loading: boolean;
  error?: string;
  updateTemperatureSettingResponse?: IUpdateTemperatureResponse;
}

const defaultState: UpdateTemperatureSettingReducerType = {
  loading: false,
  error: undefined,
  updateTemperatureSettingResponse: undefined,
};

export const updateTempertureSettingReducer =
  createReducer<UpdateTemperatureSettingReducerType>(defaultState, {
    [ActionType.UPDATE_TEMPERATURE_SETTING](
      state: UpdateTemperatureSettingReducerType
    ) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.UPDATE_TEMPERATURE_SETTING_ERROR](
      state: UpdateTemperatureSettingReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.UPDATE_TEMPERATURE_SETTING_SUCCESS](
      state: UpdateTemperatureSettingReducerType,
      action: Action<IUpdateTemperatureResponse>
    ) {
      return {
        ...state,
        loading: false,
        updateTemperatureSettingResponse: action.payload,
      };
    },

    [ActionType.RESET_TEMPERATURE_SETTING](
      state: UpdateTemperatureSettingReducerType
    ) {
      return {
        ...state,
        loading: false,
        updateTemperatureSettingResponse: {},
      };
    },
  });
